import React /* , { useEffect, useState } */ from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const isAuthenticated = !!localStorage.getItem('accessToken');

  return isAuthenticated ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL || ''}/login`} replace />;
};

export default PrivateRoute;
